/* eslint-disable @angular-eslint/no-output-native */
/* eslint-disable @angular-eslint/no-input-rename */
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  Output,
  EventEmitter,
  ViewEncapsulation,
} from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { Observable } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { delay } from 'rxjs/operators';

import * as rootReducer from 'app/core/store/index';
import * as fromSelectors from 'app/core/store/selectors/index';
import { Delivery, InboxDelivery } from 'app/core/models';
import { getScrollPosition } from 'app/inbox/inbox-deliveries/store/inbox.selectors';

@Component({
  standalone: false,
  selector: 'pptl-delivery-list',
  templateUrl: 'delivery-list.component.html',
  styleUrls: ['delivery-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class DeliveryListComponent {
  @Input('deliveries')
  set items(value: Delivery[]) {
    this.deliveries = value;
    this.cd.markForCheck();
  }

  @Input() parentId?: 'inbox' | 'favorite' | 'channel';
  @Input() highlight: string;
  @Input() channelId?: string;
  @Input() isLoading = false;
  @Output() chooseDelivery?: EventEmitter<any> = new EventEmitter<any>();
  @Output() scroll?: EventEmitter<any> = new EventEmitter<any>();
  @Output() refresh?: EventEmitter<any> = new EventEmitter<any>();

  public viewType$: Observable<'thumbnail' | 'list'>;
  public scrollPosition$: Observable<number>;
  public deliveries: Delivery[] = [];

  constructor(
    private store: Store<rootReducer.State>,
    private router: Router,
    public modalController: ModalController,
    private cd: ChangeDetectorRef,
  ) {
    this.viewType$ = this.store.pipe(
      select(fromSelectors.getFilterDisplayView),
      delay(300),
    );
    this.scrollPosition$ = this.store.pipe(select(getScrollPosition));
  }

  onDeliveryClick(delivery: InboxDelivery): void {
    if (this.chooseDelivery && !delivery.expired) {
      this.router.navigate([`/delivery/${delivery.deliveryKeyCode}/home`]);

      this.chooseDelivery.emit(delivery);
    }
  }

  onScroll(event: any): void {
    this.scroll.emit(event);
  }

  pullDown(event: any): void {
    this.refresh.emit(event);
  }
}
